import React from "react";

import { ImageEditor, ModalDialog } from "@culturehq/components";
import ChqModalDialog from "components/common/ChqModalDialog";
import { SelectedMedia } from "components/stories/types";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import { PostStoryState } from "../../types";

const CropImage = () => {
  const {
    state: { cropperOpened, selectedImages, indexImageToCrop },
    getSelectedMediaUrl,
    handleCropperClose,
    handleUpdateImages
  } = usePostStoryContext();

  const handleImageEdited = (croppedImage: Blob) => {
    const updatedImages: PostStoryState["selectedImages"] = [...selectedImages];
    updatedImages[indexImageToCrop] = croppedImage;
    handleUpdateImages(updatedImages);
  };

  const handleImageFailure = () => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(indexImageToCrop, 1);
    handleUpdateImages(updatedImages);
  };

  if (!cropperOpened || (typeof indexImageToCrop !== "number")) {
    return <></>;
  }

  return (
    <ChqModalDialog onClose={handleCropperClose}>
      <ModalDialog.Body>
        <ImageEditor
          image={getSelectedMediaUrl(
            selectedImages[indexImageToCrop] as SelectedMedia
          )}
          onEdit={handleImageEdited}
          onFailure={handleImageFailure}
        />
      </ModalDialog.Body>
    </ChqModalDialog>
  );
};

export default CropImage;
